import { PostData } from '../types';
import { MediaType } from '../../../../../models/graphql';

export const wideFeedImage = (data: PostData) =>
  data.media &&
  data.media.type === MediaType.PHOTO &&
  data.media.width > data.media.height &&
  data.media.width / data.media.height > 1.91;
